import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api_plateforme, RunTimeDataService, api_collection_plateform } from '@leandredev/dcbm-ng-lib';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { I_Data_Env } from 'src/environments/interface';

@Injectable()
export class ApiService implements Partial<Api_plateforme> {
  private service: Api_plateforme;

  constructor(private http: HttpClient, private runTimeDataService: RunTimeDataService) {
    this.service = new Api_plateforme(this.http);
    this.service.urlApi = `${environment.data.api}bdd/`;

    this.runTimeDataService
      .getObservableStore('publicConf')
      .pipe(
        map((data: I_Data_Env) => {
          if (data) this.service.urlApi = `${data.api}bdd/`;
        })
      )
      .subscribe();
  }

  get collections(): api_collection_plateform {
    return this.service.collections;
  }

  // ===================================================================================================================

  readonly fileUploadServiceUrl = `${environment.data.uploadapi}filesService/`;
}
